import React from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { Space, Button, message } from "@mimber/ui-web"
import { Form, InputField } from "@mimber/forms"
import { useCreateRole } from "@mimber/client/mimber-organization"
import { CreateOrganizationRoleDtoSchema } from "@mimber/schema"
import type { CreateOrganizationRoleDto } from "@mimber/schema"
import type { CreateRoleFormProps } from "./CreateRoleForm.types"

export const CreateRoleForm: React.FunctionComponent<CreateRoleFormProps> = ({
  onSuccess,
  onCancel,
}) => {
  const form = useForm<CreateOrganizationRoleDto>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(CreateOrganizationRoleDtoSchema) as any,
    mode: "onBlur",
    defaultValues: {
      name: "",
    },
  })

  const { reset } = form

  const mutation = useCreateRole({
    onSuccess: (response) => {
      message.success("Role created successfully")
      reset()
      onSuccess?.(response.data)
    },
    onError: (error) => {
      message.error(`Failed to create role: ${error.message}`)
    },
  })

  const onSubmit = (data: CreateOrganizationRoleDto) => {
    mutation.mutate(data)
  }

  return (
    <Form
      form={form}
      onSubmit={onSubmit}
      disabled={mutation.isPending}
      layout="vertical"
    >
      <InputField
        name="name"
        label="Role Name"
        placeholder="e.g., Board Member, Treasurer"
        required
        maxLength={255}
        showCount
      />

      <Space style={{ width: "100%", justifyContent: "flex-end" }}>
        {onCancel && (
          <Button onClick={onCancel} disabled={mutation.isPending}>
            Cancel
          </Button>
        )}
        <Button type="primary" htmlType="submit" loading={mutation.isPending}>
          Create Role
        </Button>
      </Space>
    </Form>
  )
}
